var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Push") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Push"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 20)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7526132,1.46296296 C47.9501603,1.46296296 50.5505226,4.08751852 50.5505226,7.31481481 L50.5505226,71.6851852 C50.5505226,74.9124815 47.9501603,77.537037 44.7526132,77.537037 L18.6620209,77.537037 C15.4644739,77.537037 12.8641115,74.9124815 12.8641115,71.6851852 L12.8641115,7.31481481 C12.8641115,4.08751852 15.4644739,1.46296296 18.6620209,1.46296296 L44.7526132,1.46296296 Z M44.7526132,0 L18.6620209,0 C14.6759582,0 11.4146341,3.29166667 11.4146341,7.31481481 L11.4146341,71.6851852 C11.4146341,75.7083333 14.6759582,79 18.6620209,79 L44.7526132,79 C48.738676,79 52,75.7083333 52,71.6851852 L52,7.31481481 C52,3.29166667 48.738676,0 44.7526132,0 Z",
    id: "Shape",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#37474F",
    points: "28.8083624 2.92592593 34.6062718 2.92592593 34.6062718 4.38888889 28.8083624 4.38888889"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-0, 16.4583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BBCADF",
    x: 0,
    y: 0,
    width: 42.2160279,
    height: 9.69212963
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    x: 2.53658537,
    y: 3.47453704,
    width: 7.97212544,
    height: 2.92592593
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    x: 14.3135889,
    y: 3.47453704,
    width: 21.7421603,
    height: 2.92592593
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNew);
export default __webpack_public_path__ + "static/media/Push_new.eb6b5dd70679dbf3a3b5b28a93236d83.svg";
export { ForwardRef as ReactComponent };